import React, { useEffect, useState } from "react";
import axios from "axios";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const BOPurchase_Order = () => {
   useAuthRedirect();
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const startYear = 2007;

  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  /////////////////////////////////////////////////////////////     
            //✅ Permission checks (safe even if perms not yet loaded; will be false)
            const canView  = hasPermission("Branch Office Purchase Order", "view");
            const canEntry = hasPermission("Branch Office Purchase Order", "entry");
            const canDel = hasPermission("Branch Office Purchase Order", "del");
            /////////////////////////////////////////////////////////////
       

  useEffect(() => {
    fetchData();
  }, [ selectedYear, selectedMonth, branch]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/bopurchaseOrder_list", {
        params: {  month: selectedMonth, year: selectedYear, branch : branch }
      });
      setData(response.data.purchaseOrderList);
      setFilteredData(response.data.purchaseOrderList);
    } catch (error) {
      console.error("Error fetching purchaseOrderList:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
        setFilteredData(data);
        return;
    }

    const filtered = data.filter((item) => 
        String(item.purchaseOrderHeader_ponumber || "").toLowerCase().includes(term) || 
        String(item.purchaseOrderHeader_supplierName || "").toLowerCase().includes(term)
    );

    setFilteredData(filtered);
};

const handleDelete = async (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!"
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        // Show loading alert
        Swal.fire({
          title: "Deleting...",
          text: "Please wait while we process your request.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        // Delete request
        await axios.delete(`https://rfs2.infraconsoft.net.in/api/bo_delete/${id}`);

        // Update state
        setData((prevData) =>
          prevData.filter((item) => item.purchaseOrderHeader_ponumber !== id)
        );

        // Refresh data from server (optional)
        await fetchData();

        // Success alert
        Swal.fire({
          title: "Deleted!",
          text: "Your record has been deleted.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });

      } catch (error) {
        console.error("Error deleting vehicle position:", error);
        Swal.fire({
          title: "Error!",
          text: "Failed to delete BO Purchase Order position.",
          icon: "error"
        });
      }
    }
  });
};


 if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }
  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Branch Office P.O</h2>
          <Time />
        </section>

{canEntry && (
        <div className="next-container">
          <Link to={`/inventory/miscgrnmenu`}>
            <button className="next-btn">
                 Next BO GRN<i className="fa-solid fa-arrow-right"></i> 
            </button>
          </Link>
        </div>
)}


        {/* Month & Year Selection */}
        <div className="month-year-container">
          <p className="title">Select your Month & Year:</p>

          <div className="select-container">
            <select
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(12).keys()].map(i => (
                <option key={i + 1} value={i + 1}>
                  {(i + 1).toString().padStart(2, "0")}
                </option>
              ))}
            </select>

            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              className="custom-select"
            >
              {[...Array(currentYear - startYear + 1).keys()].map(i => (
                <option key={startYear + i} value={startYear + i}>
                  {startYear + i}
                </option>
              ))}
            </select>
          </div>

          <button
  className="custom-button"
  onClick={() => {
    window.location.href = '/inventory/miscPoView';
  }}
>
  View All
</button>
        </div>

        {/* Add New Button */}
        {canEntry && (
        <div className="add-new-container">
          <Link to={`/inventory/addMiscPO`}>
            <button className="add-new-btn">
              <i className="fa-solid fa-plus"></i> Add New
            </button>
          </Link>
        </div>
        )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by PO No"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>P.O No</th>
                <th>P.O Date</th>
                <th>Supplier</th>
                <th>Your Ref</th>
                <th>Your Ref Date</th>
                <th>Our Ref</th>
                <th>Our Ref Date</th>
                <th>Value</th>
                {canDel && (
                <th>Delete</th>
                )}
                <th>Print</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                      <Link to={`/inventory/miscPOViewSingle/${item.purchaseOrderHeader_ponumber}`}>
                        {item.purchaseOrderHeader_ponumber}
                      </Link>
                    </td>
                    <td>{new Date(item.purchaseOrderHeader_podate).toLocaleDateString()}</td>
                    <td>{item.purchaseOrderHeader_supplierName}</td>
                    <td>{item.purchaseOrderHeader_yourReferenceNumber}</td>
                    <td>{new Date(item.purchaseOrderHeader_yourReferenceDate).toLocaleDateString()}</td>
                    <td>{item.purchaseOrderHeader_ourReferenceNumber}</td>
                    <td>{new Date(item.purchaseOrderHeader_ourReferenceDate).toLocaleDateString()}</td>
                    
                    <td> {new Intl.NumberFormat("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(item.purchaseOrderHeader_totalValue)}</td>
                    {canDel && (
                    <td className="del">
                      <i className="fa-solid fa-trash-can " onClick={() => handleDelete(item.purchaseOrderHeader_ponumber)}></i>
                    </td>
                    )}

                    <td>
                      <Link target="_blank" to={`/inventory/miscPoView_print/${item.purchaseOrderHeader_ponumber}`}>
                      <i class="fa-solid fa-print edit"></i>
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default BOPurchase_Order;
